import { useSelector } from 'react-redux';
import getLang from 'I18n/utils/getLang';
import CoreHSPageViewTracker from 'marketplace-ui-common/tracking/components/HSPageViewTracker';
// @ts-expect-error untyped dependency
import { getAppRootUrl, getPublicRootUrl } from '../../utils/urls';
// @ts-expect-error untyped dependency
import { getIsPublic } from '../../selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
const languageCode = window.I18N_MANUAL_LANG;
export default function HSPageViewTracker({
  addLang = false,
  overrideTrack = false,
  pathname
}) {
  const isPublic = useSelector(getIsPublic);
  const urlRoot = isPublic ? getPublicRootUrl(languageCode) : getAppRootUrl();
  const _pathname = addLang ? `${urlRoot}${pathname}?user-language=${getLang()}` : `${urlRoot}${pathname}`;
  return /*#__PURE__*/_jsx(CoreHSPageViewTracker, {
    overrideTrack: overrideTrack,
    pathname: _pathname
  });
}